import {
  Module,
  VuexModule,
  Action,
  Mutation,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  API_CENTRAL_URL,
  SETTING_GET,
  SETTING_UPDATE,
  LOBBY_SETTING_GET,
  LOBBY_SETTING_UPDATE,
  M_GET,
  M_PATCH,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'setting' })
export default class Setting extends VuexModule {
  settingData: any = {
    color: {},
    logo: {},
  }

  lobbySettingData: any = {
    theme: '',
    logo: {},
  }

  @Action({ commit: 'mutateData' })
  async GetData() {
    try {
      const { data } = await Vue.axios({
        url: BASE_URL + SETTING_GET,
        method: M_GET,
      });
      const settingData = data.data;
      return {
        ...settingData,
      };
    } catch (err) {
      return err;
    }
  }

  @Mutation
  mutateData(settingData: any) {
    this.settingData = settingData;
  }

  @Action
  EditSetting(params) {
    return Vue.axios({
      url: BASE_URL + SETTING_UPDATE,
      data: params,
      method: M_PATCH,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action({ commit: 'mutateLobbyData' })
  async GetLobbyData(prefix) {
    try {
      const { data } = await Vue.axios({
        url: `${API_CENTRAL_URL}${LOBBY_SETTING_GET}?prefix=${prefix}`,
        method: M_POST,
      });
      const lobbySettingData = data.data;
      return {
        ...lobbySettingData,
      };
    } catch (err) {
      return err;
    }
  }

  @Mutation
  mutateLobbyData(lobbySettingData: any) {
    this.lobbySettingData = lobbySettingData;
  }

  @Action
  EditLobbySetting(params) {
    return Vue.axios({
      url: API_CENTRAL_URL + LOBBY_SETTING_UPDATE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }
}
